/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Filter_Nothing_PlannedInputs */



/**
* | output |
* | --- |
* | "Nothing planned ({count})" |
*
* @param {Team_Filter_Nothing_PlannedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_nothing_planned = /** @type {((inputs: Team_Filter_Nothing_PlannedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_Nothing_PlannedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Niets gepland (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rien de prévu (${i?.count})`)
	return /** @type {LocalizedString} */ (`Nothing planned (${i?.count})`)
});